<template>
  <div class="container-fluid px-0">
    <div class="row py-4" style="max-width: 1150px; margin: 0 auto">
      <div class="col-12 col-md-6 mb-4">
        <ul class="list-group cart-shell">
          <li class="list-group-item" v-if="products.length == 0">
            <div class="row">
              <div class="col-12">
                <h4 class="text-center py-5">Vacio</h4>
              </div>
            </div>
          </li>
          <li
            class="list-group-item list-group-item-action click cart-product"
            v-for="(p, i) in products"
            :key="`p-${i}`"
            @click="editProduct(p)"
          >
            <div class="row">
              <div class="col-12 col-sm-4">
                <img
                  :src="getImage(p.image)"
                  alt=""
                  class="img-fluid rounded mb-3 cart-product__image"
                />
              </div>
              <div class="col">
                <div class="row no-gutters">
                  <div class="col-8">
                    <span class="font-weight-bold d-block cart-product__title">
                      {{ p.qty }} x
                      <span class="text-uppercase">{{ p.name }}</span>
                    </span>
                  </div>
                  <div class="col-4 text-right h-50">
                    <span class="font-weight-bold cart-product__price">
                      ${{ formatNumber(p.total) }}
                    </span>
                  </div>
                  <div class="col">
                    <small class="text-muted mr-3"
                      >VALOR: ${{ formatNumber(p.value) }}</small
                    >
                    <small class="text-muted mr-3" v-if="p.extra"
                      >EXTRAS: ${{ formatNumber(p.extra) }}</small
                    >
                    <small class="text-muted" v-if="p.discount"
                      >DCTO:-${{ formatNumber(p.discount) }}</small
                    >
                  </div>
                  <div class="col col-md-3 text-right"></div>
                </div>
                <!-- <router-link class="text-dark" :to="`/${info.webName}/p/${p._id}`"> -->

                <!-- </router-link> -->
                <div class="col-12" v-if="p.details">
                  <small class="font-weight-bold">Notas: </small
                  ><small>{{ p.details }}</small>
                </div>

                <div class="d-block mt-2 cart-product__options" v-if="p.options.length > 0">
                  <small class="d-block">OPCIONES</small>
                  <div class="w-100 border-bottom py-1 ml-auto"></div>
                  <div
                    class="row"
                    v-for="(op, i) in p.options"
                    :key="`op-${i}`"
                  >
                    <div class="col-12">
                      <small class="font-weight-bold text-uppercase">
                        {{ op.name }}:
                      </small>
                    </div>
                    <div class="col-12">
                      <div class="" v-if="op.values && op.values.length > 0">
                        <small
                          class="d-block"
                          v-for="(s, i) in op.values"
                          :key="`se-${i}`"
                          >{{ s.name }}
                          <span class="text-danger" v-if="s.value"
                            >- ${{ s.value }}</span
                          ></small
                        >
                      </div>
                      <div class="" v-else-if="op.multiple && Array.isArray(op.selected)">
                        <small
                          class="d-block"
                          v-for="(s, i) in op.selected"
                          :key="`legacy-se-${i}`"
                          >{{ s.name }}
                          <span class="text-danger" v-if="s.value"
                            >- ${{ s.value }}</span
                          ></small
                        >
                      </div>
                      <small class="" v-else-if="op.type == 'number'">
                        {{ op.selected }}
                      </small>
                      <small class="" v-else>
                        {{ op.selected && op.selected.name ? op.selected.name : op.selected }}
                        <span
                          class="text-danger"
                          v-if="op.selected && op.selected.value"
                          >- ${{ op.selected.value }}</span
                        >
                      </small>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-12">
                <small
                  class="btn-link text-primary click mr-3 cart-product__edit"
                  @click.stop="editProduct(p)"
                >
                  Editar
                </small>
                <small
                  class="btn-link text-danger click cart-product__remove"
                  @click.stop="removeProduct(p)"
                >
                  Quitar
                </small>
              </div>
            </div>
          </li>
          <li class="list-group-item cart-summary__row">
            <div class="row">
              <div class="col text-right">
                <strong>SUBTOTAL</strong>
              </div>
              <div class="col-3 text-right">
                <strong>${{ formatNumber(subtotal) }}</strong>
              </div>
            </div>
          </li>
          <li class="list-group-item cart-summary__row" v-if="type == 'Domicilio'">
            <div class="row">
              <div class="col text-right">
                <strong>ENVIO</strong>
              </div>
              <div class="col-3 text-right">
                <strong>${{ formatNumber(deliveryValue) }}</strong>
              </div>
            </div>
          </li>
          <li class="list-group-item list-group-item-dark cart-summary__discount" v-if="coupon._id">
            <div class="row">
              <div class="col text-right">
                <strong>CUPON ({{ coupon.code }})</strong>
              </div>
              <div class="col-3 text-right text-dark">
                <strong>-${{ formatNumber(cuponTotal) }}</strong>
              </div>
            </div>
          </li>
          <li class="list-group-item list-group-item-dark cart-summary__total">
            <div class="row">
              <div class="col text-right">
                <strong>TOTAL</strong>
              </div>
              <div class="col-3 text-right">
                <strong>${{ formatNumber(total - cuponTotal) }}</strong>
              </div>
            </div>
          </li>
        </ul>
        <div class="mt-3 d-none1 coupon-item cart-coupon" v-if="settings.couponEnabled">
          <div class="input-group">
            <div class="input-group-prepend">
              <span class="input-group-text cart-coupon__label">
                <small>CUPON DE DESCUENTO</small>
              </span>
            </div>
            <input
              type="text"
              class="form-control font-weight-bold cart-coupon__input"
              :disabled="cuponDisabled"
              ref="couponInput"
              v-model="couponCode"
              @input="couponCode = $event.target.value.toUpperCase()"
              placeholder="(Opcional)"
              @keyup.enter="applyCoupon()"
            />
            <button
              class="btn btn-outline-primary cart-coupon__button"
              :disabled="cuponDisabled"
              @click="applyCoupon()"
            >
              <b-icon icon="arrow-right" />
            </button>
          </div>
        </div>
      </div>
      <div class="col-12 col-md-6">
        <ul class="list-group cart-shell">
          <li class="list-group-item cart-delivery-card">
            <div class="row align-items-center">
              <div class="col">
                <strong>Tipo de entrega</strong>
                <div class="w-100"></div>
                <small class="text-muted">Seleccione</small>
                <small
                  class="d-block alert alert-danger py-2"
                  v-if="total < settings.minDelivery"
                >
                  Reparto a domicilio minimo desde ${{
                    formatNumber(settings.minDelivery)
                  }}
                </small>
                <div class="btn-group w-100 cart-delivery-toggle">
                  <button
                    class="btn"
                    v-if="settings.showPickup"
                    @click="type = 'Retiro'"
                    :disabled="!pickupEnabled"
                    :class="{
                      'btn-primary': type == 'Retiro',
                      'btn-outline-primary': type != 'Retiro',
                    }"
                  >
                    RETIRO
                    <span class="d-block" v-if="!pickupEnabled"
                      >(No disponible)</span
                    >
                    <small
                      class="d-block font-italic"
                      v-if="pickupEnabled && settings.pickupWaitTime"
                      >{{ settings.pickupWaitTime }} min aprox.</small
                    >
                  </button>
                  <button
                    class="btn"
                    @click="type = 'Domicilio'"
                    v-if="settings.showDelivery"
                    :disabled="!deliveryEnabled || total < settings.minDelivery"
                    :class="{
                      'btn-primary': type == 'Domicilio',
                      'btn-outline-primary': type != 'Domicilio',
                    }"
                  >
                    DOMICILIO
                    <span class="d-block text-danger" v-if="!deliveryEnabled"
                      >(No disponible)</span
                    >
                    <small
                      class="d-block font-italic"
                      v-if="deliveryEnabled && settings.deliveryWaitTime"
                      >{{ settings.deliveryWaitTime }} min aprox.</small
                    >
                  </button>

                  <button
                    class="btn"
                    @click="type = 'Envio'"
                    v-if="settings.showShipping"
                    :disabled="!shippingEnabled || total < settings.minDelivery"
                    :class="{
                      'btn-primary': type == 'Envio',
                      'btn-outline-primary': type != 'Envio',
                    }"
                  >
                    ENVIO
                    <div class="w-100"></div>
                    <small>POR PAGAR</small>
                    <span class="d-block text-danger" v-if="!shippingEnabled"
                      >(No disponible)</span
                    >
                  </button>
                </div>

                <div class="w-100"></div>
                <!-- schedule ticekt to date -->

                <div
                  class="row mt-2"
                  v-if="type != '' && settings.showSchedule"
                >
                  <div class="col-6">
                    <div class="form-group d-none1">
                      <label for="date" class="font-weight-bold"
                        >Agendar para</label
                      >
                      <select
                        class="form-control"
                        v-model="date"
                        :disabled="!settings.scheduleEnabled"
                      >
                        <option
                          :value="day.date"
                          v-for="day in days"
                          :key="`day-${day.n}`"
                        >
                          {{ day.text }}
                        </option>
                        <!-- <option value="0">
                          Hoy, {{ $moment().format("dddd DD [de] MMMM") }}
                        </option>
                        <option value="1">
                          Mañana,
                          {{
                            $moment().add(1, "day").format("dddd DD [de] MMMM")
                          }}
                        </option>
                        <option value="2">
                          {{
                            $moment().add(2, "day").format("dddd DD [de] MMMM")
                          }}
                        </option> -->
                      </select>
                    </div>
                  </div>
                  <div class="col">
                    <label for="date" class="font-weight-bold">Hora</label>
                    <select
                      class="form-control"
                      v-model="time"
                      :class="{
                        'is-invalid': time == 'null',
                        'is-valid': time != 'null',
                      }"
                    >
                      <option :value="-1">Lo antes posible</option>
                      <option :value="i" v-for="i in hours" :key="`hour-${i}`">
                        {{ formatScheduleTime(i) }}
                      </option>
                    </select>
                  </div>
                  <div class="col-12" v-if="date && !isTodayDate(date)">
                    <div class="alert alert-info mb-0">
                      <small class="font-weight-bold"
                        >Su pedido quedará a confirmacion del local. Se enviará
                        confirmacion al correo</small
                      >
                    </div>
                  </div>
                </div>

                <select
                  name=""
                  v-model="type"
                  class="form-control d-none"
                  :class="{
                    'is-invalid':
                      (type == 'Retiro' && !pickupEnabled) ||
                      (type == 'Domicilio' && !deliveryEnabled),
                    'is-valid':
                      (type != 'Retiro' && !pickupEnabled) ||
                      (type != 'Domicilio' && !deliveryEnabled),
                  }"
                >
                  <option value="Retiro" :disabled="!pickupEnabled">
                    Retiro en local
                    <span v-if="!pickupEnabled">(No disponible)</span>
                  </option>
                  <option
                    value="Domicilio"
                    :disabled="!deliveryEnabled || total < settings.minDelivery"
                  >
                    Reparto a domicilio
                    <span v-if="!deliveryEnabled">(No disponible)</span>
                  </option>
                </select>
              </div>
            </div>
          </li>
          <li class="list-group-item" v-if="type == 'Domicilio'">
            <div class="row">
              <div class="col-12">
                <div class="cart-address-hint">
                  <strong>Completa aquí calle y número.</strong>
                  <small class="d-block">
                    Block, depto, casa interior, condominio u otras referencias
                    las puedes agregar al final del pedido.
                  </small>
                </div>
              </div>
              <div class="col">
                <strong>Direccion</strong>
                <div class="w-100"></div>
                <!-- <button class="btn btn-primary" @click="useLocation()">
                  USAR MI UBICACION
                </button> -->
                <!-- <gmap-autocomplete
                  :value="address"
                  ref="addressInput"
                  :componentRestrictions="{ country: 'CL' }"
                  placeholder="Ej: Avenida 123, Comuna"
                  @place_changed="getAddressData"
                  class="form-control"
                  :select-first-on-enter="true"
                >
                </gmap-autocomplete> -->
                <div class="w-100"></div>
                <div class="input-group">
                  <input
                    type="text"
                    v-model="address"
                    class="form-control d-none1"
                    :class="{
                      'is-invalid': address.length < 4,
                      'is-valid': address.length >= 4,
                    }"
                    @blur="searchAddressWeb()"
                  />
                  <button
                    class="btn btn-outline-success"
                    :disabled="searching"
                    @click="searchAddressWeb()"
                  >
                    Buscar
                  </button>
                </div>
                <small class="text-muted"> Calle y numero </small>
                <button
                  type="button"
                  class="btn btn-link btn-sm px-0 ml-2 cart-address-edit"
                  @click="changeAddress()"
                >
                  Ajustar ubicacion en el mapa
                </button>
              </div>
              <div class="col-5 d-none">
                <strong>Comuna</strong>
                <div class="w-100"></div>
                <select
                  v-model="comunne"
                  @change="searchAddress()"
                  class="form-control"
                  :class="{
                    'is-invalid': !comunne._id,
                    'is-valid': comunne.name,
                  }"
                >
                  <option :value="{}" disabled>Seleccione</option>
                  <option
                    class="text-uppercase"
                    :value="z"
                    :key="i"
                    v-for="(z, i) in comunnes"
                  >
                    {{ z.name }}
                  </option>
                </select>
                <small class="text-muted"> Para calcular el envio </small>
              </div>
              <div
                class="col-12"
                :class="{
                  'd-none': type != 'Domicilio',
                }"
              >
                <strong>Sector encontrado</strong>
                <div class="w-100"></div>
                <select
                  v-model="zone"
                  disabled
                  class="form-control"
                  :class="{
                    'is-invalid': !zone._id,
                    'is-valid': zone.name,
                  }"
                >
                  <option :value="{}" disabled>- - - - - - -</option>
                  <option :value="z" :key="i" v-for="(z, i) in zones">
                    {{ z.name }}
                    <span v-if="z.value">- ${{ formatNumber(z.value) }}</span>
                  </option>
                </select>
                <small class="text-muted"> Ubicacion aproximada </small>
              </div>
            </div>
            <div
              class="row"
              v-if="center"
              :class="{
                'd-none': type != 'Domicilio',
              }"
            >
              <gmap-map
                :center="center"
                :options="{
                  mapTypeControl: false,
                  scaleControl: false,
                  streetViewControl: false,
                }"
                :zoom="zoom"
                style="width: 100%; height: 250px"
              >
                <GmapMarker :position="center" />
                <component
                  :is="path.type == 'zone' ? 'gmap-polygon' : 'gmap-circle'"
                  v-for="(path, i) in zones"
                  :key="`path-${i}`"
                  :paths="path.paths"
                  :center="path.center"
                  :radius="path.radius"
                  :options="{
                    strokeColor: path.color,
                  }"
                />
              </gmap-map>
            </div>
          </li>
          <li class="list-group-item" v-if="type == 'Envio'">
            <div class="row">
              <div class="col-12">
                <div class="cart-address-hint">
                  <strong>Completa aquí calle y número.</strong>
                  <small class="d-block">
                    Block, depto, casa interior, condominio u otras referencias
                    las puedes agregar al final del pedido.
                  </small>
                </div>
              </div>
              <div class="col">
                <strong>Direccion</strong>
                <div class="w-100"></div>
                <!-- <button class="btn btn-primary" @click="useLocation()">
                  USAR MI UBICACION
                </button> -->
                <!-- <gmap-autocomplete
                  :value="address"
                  ref="addressInput"
                  :componentRestrictions="{ country: 'CL' }"
                  placeholder="Ej: Avenida 123, Comuna"
                  @place_changed="getAddressData"
                  class="form-control"
                  :select-first-on-enter="true"
                >
                </gmap-autocomplete> -->
                <input
                  type="text"
                  v-model="address"
                  placeholder="Calle 123"
                  class="form-control d-none1"
                  :class="{
                    'is-invalid': address.length < 4,
                    'is-valid': address.length >= 4,
                  }"
                />

                <div class="w-100 py-2"></div>

                <strong>Comuna</strong>
                <div class="w-100"></div>
                <input
                  type="text"
                  placeholder="Ingrese una comuna"
                  v-model="commune"
                  class="form-control d-none1"
                  :class="{
                    'is-invalid': commune.length < 4,
                    'is-valid': commune.length >= 4,
                  }"
                />
                <!-- <select class="form-control">
                  <option
                    value="1"
                    v-for="commune in communes"
                    :key="commune._id"
                  >
                    {{ commune.name }}
                  </option>
                </select> -->
              </div>
              <div class="col-5 d-none">
                <strong>Comuna</strong>
                <div class="w-100"></div>
                <select
                  v-model="comunne"
                  @change="searchAddress()"
                  class="form-control"
                  :class="{
                    'is-invalid': !comunne._id,
                    'is-valid': comunne.name,
                  }"
                >
                  <option :value="{}" disabled>Seleccione</option>
                  <option
                    class="text-uppercase"
                    :value="z"
                    :key="i"
                    v-for="(z, i) in comunnes"
                  >
                    {{ z.name }}
                  </option>
                </select>
                <small class="text-muted"> Para calcular el envio </small>
              </div>

              <div
                class="col-12"
                :class="{
                  'd-none': type != 'Domicilio',
                }"
              >
                <strong>Sector encontrado</strong>
                <div class="w-100"></div>
                <select
                  v-model="zone"
                  disabled
                  class="form-control"
                  :class="{
                    'is-invalid': !zone._id,
                    'is-valid': zone.name,
                  }"
                >
                  <option :value="{}" disabled>- - - - - - -</option>
                  <option :value="z" :key="i" v-for="(z, i) in zones">
                    {{ z.name }}
                    <span v-if="z.value">- ${{ formatNumber(z.value) }}</span>
                  </option>
                </select>
                <small class="text-muted"> Ubicacion aproximada </small>
              </div>
            </div>
            <div
              class="row"
              v-if="center"
              :class="{
                'd-none': type != 'Domicilio',
              }"
            >
              <gmap-map
                :center="center"
                :options="{
                  mapTypeControl: false,
                  scaleControl: false,
                  streetViewControl: false,
                }"
                :zoom="zoom"
                style="width: 100%; height: 250px"
              >
                <GmapMarker :position="center" />
                <component
                  :is="path.type == 'zone' ? 'gmap-polygon' : 'gmap-circle'"
                  v-for="(path, i) in zones"
                  :key="`path-${i}`"
                  :paths="path.paths"
                  :center="path.center"
                  :radius="path.radius"
                  :options="{
                    strokeColor: path.color,
                  }"
                />
              </gmap-map>
            </div>
          </li>
          <li class="list-group-item" v-if="type == 'Envio'">
            <div class="row">
              <div class="col">
                <strong>Rut</strong>
                <div class="w-100"></div>
                <input
                  type="text"
                  v-model="rut"
                  class="form-control"
                  :class="{
                    'is-invalid': rut.length < 7,
                    'is-valid': rut.length >= 7,
                  }"
                  placeholder="Ingresa tu rut. Ej: 12345678-9"
                />
              </div>
            </div>
          </li>
          <li class="list-group-item" v-if="type != ''">
            <div class="row">
              <div class="col">
                <strong>Tu Nombre</strong>
                <div class="w-100"></div>
                <input
                  type="text"
                  v-model="clientName"
                  :disabled="isLogged()"
                  class="form-control"
                  :class="{
                    'is-invalid': clientName.length < 3,
                    'is-valid': clientName.length >= 3,
                  }"
                  placeholder="Ingresa tu nombre"
                />
              </div>
            </div>
          </li>
          <li class="list-group-item" v-if="type != ''">
            <div class="row">
              <div class="col">
                <strong>Telefono</strong>
                <div class="w-100"></div>
                <div class="input-group">
                  <div class="input-group-prepend">
                    <span class="input-group-text">+56</span>
                  </div>
                  <input
                    type="tel"
                    :disabled="isLogged()"
                    :class="{
                      'is-invalid':
                        phone.length != 9 || !phone.match(/^[0-9]+$/),
                      'is-valid': phone.length == 9 && phone.match(/^[0-9]+$/),
                    }"
                    v-model.trim="phone"
                    class="form-control"
                    placeholder="987654321"
                  />
                </div>
                <small class="text-danger" v-if="!phone.match(/^[0-9]+$/)">
                  Ingrese un telefono valido
                </small>
                <small class="text-muted">Necesario para contacto</small>
              </div>
            </div>
          </li>
          <li class="list-group-item" v-if="type != ''">
            <div class="row">
              <div class="col">
                <strong>Correo</strong>
                <div class="w-100"></div>
                <input
                  type="email"
                  v-model="email"
                  class="form-control"
                  autocapitalize="off"
                  :disabled="isLogged()"
                  :class="{
                    'is-invalid': emailIsValid,
                    'is-valid': !emailIsValid,
                  }"
                  placeholder="Ej: mi@correo.cl"
                  @change="email = $event.target.value.toLowerCase()"
                />
                <small class="text-muted">
                  Te enviaremos actualizaciones de tu pedido
                </small>
              </div>
            </div>
          </li>
          <li class="list-group-item" v-if="type != ''">
            <div class="row">
              <div class="col">
                <strong>Medio de pago</strong>
                <div class="w-100"></div>
                <small class="text-muted d-block mt-2">
                  Toca una opción para seleccionarla
                </small>
                <div class="payment-grid">
                  <button
                    v-if="settings.flowEnabled"
                    type="button"
                    class="btn payment-chip"
                    :class="{
                      'payment-chip--online': true,
                      'payment-chip--active': payment && payment.name == 'Webpay',
                      'payment-chip--disabled': false,
                    }"
                    @click="payment = { name: 'Webpay' }"
                  >
                    <strong class="d-block">{{ normalizePaymentLabel("Webpay") }}</strong>
                    <small class="d-block">Pago en linea</small>
                  </button>
                  <button
                    v-if="settings.mercadoPagoEnabled"
                    type="button"
                    class="btn payment-chip"
                    :class="{
                      'payment-chip--online': true,
                      'payment-chip--active': payment && payment.name == 'MercadoPago',
                      'payment-chip--disabled': false,
                    }"
                    @click="payment = { name: 'MercadoPago' }"
                  >
                    <strong class="d-block">{{ normalizePaymentLabel("MercadoPago") }}</strong>
                    <small class="d-block">Pago en linea</small>
                  </button>
                  <button
                    v-if="settings.klapEnabled"
                    type="button"
                    class="btn payment-chip"
                    :class="{
                      'payment-chip--online': true,
                      'payment-chip--active': payment && payment.name == 'Klap',
                      'payment-chip--disabled': false,
                    }"
                    @click="payment = { name: 'Klap' }"
                  >
                    <strong class="d-block">{{ normalizePaymentLabel("Klap") }}</strong>
                    <small class="d-block">Pago en linea</small>
                  </button>
                  <button
                    type="button"
                    class="btn payment-chip"
                    :class="{
                      'payment-chip--cash': p.name && p.name.toLowerCase().includes('efectivo'),
                      'payment-chip--card': p.name && (
                        p.name.toLowerCase().includes('tarjeta') ||
                        p.name.toLowerCase().includes('debito') ||
                        p.name.toLowerCase().includes('credito')
                      ),
                      'payment-chip--benefit': p.name && (
                        p.name.toLowerCase().includes('sodexo') ||
                        p.name.toLowerCase().includes('edenred') ||
                        p.name.toLowerCase().includes('amipass')
                      ),
                      'payment-chip--bank': p.name && (
                        p.name.toLowerCase().includes('transferencia') ||
                        p.name.toLowerCase().includes('transferir') ||
                        p.name.toLowerCase().includes('banco')
                      ),
                      'payment-chip--active': payment && payment.name == p.name,
                      'payment-chip--disabled': checkPayment(p),
                    }"
                    :disabled="checkPayment(p)"
                    :value="p"
                    v-for="(p, i) in payments"
                    :key="`payment-${i}`"
                    @click="payment = p"
                  >
                    <strong class="d-block">{{ normalizePaymentLabel(p.name) }}</strong>
                    <small class="d-block" v-if="checkPayment(p)">
                      No disponible para esta entrega
                    </small>
                  </button>
                </div>
                <select
                  v-model="payment"
                  class="form-control d-none"
                  :class="{
                    'is-invalid': payment == '',
                    'is-valid': payment != '',
                  }"
                >
                  <option value="" disabled>Seleccione</option>
                  <option
                    v-if="settings.flowEnabled"
                    :value="{ name: 'Webpay' }"
                  >
                    Pago en linea - WebPay
                  </option>
                  <option
                    v-if="settings.mercadoPagoEnabled"
                    :value="{ name: 'MercadoPago' }"
                  >
                    Pago en linea - MercadoPago
                  </option>
                  <option v-if="settings.klapEnabled" :value="{ name: 'Klap' }">
                    Pago en linea - Klap
                  </option>
                  <option
                    :disabled="checkPayment(p)"
                    :value="p"
                    v-for="(p, i) in payments"
                    :key="i"
                  >
                    {{ p.name }}
                    <span v-if="checkPayment(p)">
                      (No disponible para el tipo de entrega)</span
                    >
                  </option>
                </select>
                <div
                  class="payment-details mt-3"
                  v-if="!payment.showDetailsOnConfirm && payment.details"
                >
                  <small class="payment-details__label">Importante</small>
                  <div v-html="paymentDetails"></div>
                </div>
              </div>
            </div>
          </li>
          <li class="list-group-item" v-if="type != '' && settings.tipEnabled">
            <div class="row">
              <div class="col">
                <strong>Propina (Opcional)</strong>
                <div class="w-100"></div>
                <div class="input-group">
                  <div class="input-group-prepend">
                    <span class="input-group-text">$</span>
                  </div>
                  <input
                    type="number"
                    v-model.number="tip"
                    class="form-control"
                    :class="{
                      'is-invalid': tip < 0,
                      'is-valid': tip >= 0,
                    }"
                    placeholder="0"
                  />
                </div>
                <div class="payment-grid amount-shortcuts mt-3">
                  <button
                    class="btn payment-chip payment-chip--compact"
                    :class="{ 'payment-chip--active': tip === 500 }"
                    @click="setTip(500)"
                  >
                    <strong class="d-block">$500</strong>
                    <small class="d-block">Propina rápida</small>
                  </button>
                  <button
                    class="btn payment-chip payment-chip--compact"
                    :class="{ 'payment-chip--active': tip === 1000 }"
                    @click="setTip(1000)"
                  >
                    <strong class="d-block">$1.000</strong>
                    <small class="d-block">Propina rápida</small>
                  </button>
                  <button
                    class="btn payment-chip payment-chip--compact"
                    :class="{ 'payment-chip--active': tip === 2000 }"
                    @click="setTip(2000)"
                  >
                    <strong class="d-block">$2.000</strong>
                    <small class="d-block">Propina rápida</small>
                  </button>
                  <button
                    class="btn payment-chip payment-chip--compact"
                    :class="{ 'payment-chip--active': tip === parseInt(total * 0.1) }"
                    @click="recomendedTip()"
                  >
                    <strong class="d-block">10%</strong>
                    <small class="d-block">Sugerida</small>
                  </button>
                </div>
              </div>
            </div>
          </li>
          <li class="list-group-item" v-if="payment.needAmount">
            <div class="row">
              <div class="col">
                <strong>Cantidad con la pagas</strong>
                <small class="text-muted d-block mt-2">
                  Necesario para calcular vuelto
                </small>
                <div class="w-100"></div>
                <div class="input-group amount-group mt-2">
                  <div class="input-group-prepend">
                    <span class="input-group-text">$</span>
                  </div>
                  <input
                    type="text"
                    class="form-control"
                    v-model.number="amount"
                    ref="amountInput"
                    :class="{
                      'is-invalid': amount + tip < total,
                      'is-valid': amount + tip >= total,
                    }"
                    @focus="$event.target.select()"
                  />
                </div>
                <div class="payment-grid amount-shortcuts mt-3">
                  <button
                    class="btn payment-chip payment-chip--compact"
                    @click="setTotal()"
                  >
                    <strong class="d-block">Con lo justo</strong>
                    <small class="d-block">${{ formatNumber(total + tip) }}</small>
                  </button>
                  <button
                    class="btn payment-chip payment-chip--compact"
                    @click="amount = 10000"
                    v-if="10000 >= total + tip - cuponTotal"
                  >
                    <strong class="d-block">$10.000</strong>
                    <small class="d-block">Vuelto rapido</small>
                  </button>
                  <button
                    class="btn payment-chip payment-chip--compact"
                    @click="amount = 15000"
                    v-if="15000 >= total + tip - cuponTotal"
                  >
                    <strong class="d-block">$15.000</strong>
                    <small class="d-block">Vuelto rapido</small>
                  </button>
                  <button
                    class="btn payment-chip payment-chip--compact"
                    @click="amount = 20000"
                    v-if="20000 >= total + tip - cuponTotal"
                  >
                    <strong class="d-block">$20.000</strong>
                    <small class="d-block">Vuelto rapido</small>
                  </button>
                </div>
              </div>
            </div>
          </li>
          <li class="list-group-item" v-if="type != ''">
            <div class="row">
              <div class="col">
                <strong>Notas adicionales</strong>
              </div>
              <div class="col-12 mt-2">
                <textarea
                  placeholder="Opcional"
                  v-model="notes"
                  rows="3"
                  class="form-control"
                ></textarea>
              </div>
            </div>
          </li>
        </ul>
      </div>

      <div class="col-12 mt-4 mb-5">
        <div class="text-center">
          <span class="d-block mt-2">
            Al utilizar el sitio aceptas los
            <router-link class="font-weight-bold" :to="getLink('tos')"
              >terminos y condiciones</router-link
            >
          </span>
          <button
            class="btn btn-success btn-block btn-lg py-3"
            @click="confirmTicket()"
            :disabled="!ticketState"
            v-if="settings.status != 'offline'"
          >
            ENVIAR PEDIDO
          </button>
        </div>
      </div>
    </div>

    <b-modal
      ref="modalAddress"
      title="Buscar direccion"
      cancel-title="Volver"
      ok-title="Confirmar"
      ok-variant="success"
      @shown="focusAddressInput"
    >
      <div class="row">
        <div class="col">
          <strong>Direccion</strong>
          <!-- <button class="btn btn-primary" @click="useLocation()">
                  USAR MI UBICACION
                </button> -->
          <gmap-autocomplete
            :value="address"
            ref="addressInput"
            :componentRestrictions="{ country: 'CL' }"
            placeholder="Ej: Avenida 123, Comuna"
            @place_changed="getAddressData"
            class="form-control"
            :select-first-on-enter="true"
            style="z-index: 10"
          >
          </gmap-autocomplete>
        </div>
      </div>
    </b-modal>

    <b-modal
      ref="modal"
      title="Confirmar Pedido"
      cancel-title="Volver"
      ok-title="Confirmar y enviar"
      ok-variant="success"
      @ok="sendTicket()"
    >
      <div class="confirm-modal">
        <div class="confirm-modal__hero text-center">
          <small class="confirm-modal__eyebrow">Revisión final</small>
          <h4 class="mb-2">
            Hola <span class="text-uppercase">{{ clientName }}</span>
          </h4>
          <p class="mb-0">
            Estas ordenando para <strong>{{ type }}</strong> y te contactaremos
            al <strong>{{ phone }}</strong> si es necesario.
          </p>
        </div>

        <div class="confirm-modal__grid mt-3">
          <div class="confirm-modal__card">
            <small class="confirm-modal__label">Entrega</small>
            <strong class="d-block mb-2">{{ type }}</strong>
            <div v-if="type == 'Retiro'">
              <span class="d-block">{{ info.address }} - {{ info.commune }}</span>
              <button
                class="btn btn-outline-info btn-sm btn-block mt-3"
                @click="openAddres()"
              >
                Ver en Maps
              </button>
            </div>
            <div v-else-if="type == 'Domicilio' || type == 'Envio'">
              <span class="d-block">{{ address }}</span>
            </div>
          </div>

          <div class="confirm-modal__card">
            <small class="confirm-modal__label">Pago</small>
            <strong class="d-block mb-2">{{ payment && payment.name }}</strong>
            <span class="d-block">
              Total: ${{ formatNumber(total + tip - cuponTotal) }}
            </span>
            <span class="d-block" v-if="payment.needAmount">
              Paga con: ${{ formatNumber(amount) }}
            </span>
          </div>
        </div>

        <div class="alert alert-info mt-3 mb-0" v-if="date && !isTodayDate(date)">
          Tu pedido fue programado para
          <strong>{{ $moment(date).format("dddd DD [de] MMMM") }}</strong>
          <span v-if="time === -1 || time === '-1'">, lo antes posible</span>
          <span v-else> a las {{ formatScheduleTime(time) }}</span>
        </div>

        <div class="confirm-modal__card mt-3" v-if="notes">
          <small class="confirm-modal__label">Notas adicionales</small>
          <span class="font-italic">{{ notes }}</span>
        </div>

        <div class="confirm-ticket mt-3">
          <div class="confirm-ticket__header">
            <small class="confirm-modal__label mb-0">Mini-ticket</small>
            <strong>{{ products.length }} producto<span v-if="products.length !== 1">s</span></strong>
          </div>

          <div
            class="confirm-ticket__item"
            v-for="(p, index) in products"
            :key="`confirm-product-${index}`"
          >
            <div class="confirm-ticket__row">
              <div>
                <strong>{{ p.qty }} x {{ p.name }}</strong>
                <small class="d-block text-muted">Valor unitario ${{ formatNumber(p.value) }}</small>
              </div>
              <strong>${{ formatNumber(p.total) }}</strong>
            </div>
            <div class="confirm-ticket__options" v-if="p.options && p.options.length > 0">
              <div
                class="confirm-ticket__option"
                v-for="(op, optionIndex) in p.options"
                :key="`confirm-option-${index}-${optionIndex}`"
              >
                <strong>{{ op.name || op.label }}:</strong>
                <span v-if="op.values && op.values.length > 0">
                  {{ op.values.map((value) => value.name).join(", ") }}
                </span>
                <span v-else>{{ op.selected }}</span>
              </div>
            </div>
          </div>

          <div class="confirm-ticket__totals">
            <div class="confirm-ticket__total-row">
              <span>Sub-total</span>
              <strong>${{ formatNumber(subtotal) }}</strong>
            </div>
            <div class="confirm-ticket__total-row" v-if="type == 'Domicilio'">
              <span>Envío</span>
              <strong>${{ formatNumber(deliveryValue) }}</strong>
            </div>
            <div class="confirm-ticket__total-row" v-if="tip > 0">
              <span>Propina</span>
              <strong>${{ formatNumber(tip) }}</strong>
            </div>
            <div class="confirm-ticket__total-row" v-if="cuponTotal > 0">
              <span>Descuento</span>
              <strong>- ${{ formatNumber(cuponTotal) }}</strong>
            </div>
            <div class="confirm-ticket__total-row confirm-ticket__total-row--grand">
              <span>Total</span>
              <strong>${{ formatNumber(total + tip - cuponTotal) }}</strong>
            </div>
          </div>
        </div>

        <div
          class="alert alert-info mt-3 mb-0"
          v-if="!payment.showDetailsOnConfirm && payment.details"
        >
          <small class="mb-2 d-block font-weight-bold">Información para el pago</small>
          <div v-html="paymentDetails"></div>
        </div>
      </div>
    </b-modal>

    <b-modal
      id="cart-edit-product-modal"
      ref="modalEditProduct"
      :body-class="getThemeBody()"
      :header-class="getThemeBody()"
      :title="editingProductName ? `Editar ${editingProductName}` : 'Editar producto'"
      title-class="text-uppercase"
      size="lg"
      scrollable
      hide-footer
      no-close-on-backdrop
      @show="console.log('cart edit modal show event')"
      @shown="console.log('cart edit modal shown event')"
      @hide="closeEditProductModal"
    >
      <product
        v-if="editingProductId"
        :key="editingProductModalKey"
        :id="editingProductId"
        :editing="true"
        @success="handleEditProductSuccess"
        :textColor="getThemeText()"
      />
    </b-modal>
  </div>
</template>

<style>
.pac-container {
  z-index: 1051 !important;
}
.modal {
  z-index: 20;
}
.modal-backdrop {
  z-index: 10;
}

.cart-shell {
  gap: 0.75rem;
}

.cart-shell .list-group-item {
  border-radius: 16px;
  border: 1px solid #dbe3ef;
  box-shadow: 0 10px 28px rgba(15, 23, 42, 0.04);
}

.cart-product {
  padding: 1.1rem;
}

.cart-product__image {
  width: 100%;
  max-height: 148px;
  object-fit: cover;
  box-shadow: 0 8px 20px rgba(15, 23, 42, 0.08);
}

.cart-product__title {
  color: #334155;
  font-size: 1.05rem;
}

.cart-product__price {
  color: #0f172a;
  font-size: 1.1rem;
}

.cart-product__options {
  padding: 0.7rem 0.85rem;
  background: #f8fafc;
  border-radius: 12px;
}

.cart-product__remove {
  font-weight: 600;
}

.cart-product__edit {
  font-weight: 600;
}

.cart-summary__row {
  background: #fff;
}

.cart-summary__discount {
  background: #fff7ed;
  color: #9a3412;
}

.cart-summary__total {
  background: linear-gradient(180deg, #e2e8f0 0%, #cbd5e1 100%);
}

.cart-coupon .input-group {
  align-items: stretch;
  border-radius: 14px;
  box-shadow: 0 10px 28px rgba(15, 23, 42, 0.04);
}

.cart-coupon__label {
  background: #eff6ff;
  border-color: #bfdbfe;
  color: #1d4ed8;
  border-top-left-radius: 14px;
  border-bottom-left-radius: 14px;
}

.cart-coupon__input {
  border-left: 0;
  border-right: 0;
  min-height: 46px;
}

.cart-coupon__button {
  min-width: 64px;
  background: #fff;
  border-top-right-radius: 14px;
  border-bottom-right-radius: 14px;
  margin-left: 0;
}

.cart-delivery-card {
  padding: 1.2rem;
}

.cart-address-hint {
  margin-bottom: 1rem;
  padding: 0.95rem 1rem;
  background: linear-gradient(180deg, #f0f9ff 0%, #ecfeff 100%);
  border: 1px solid #bae6fd;
  border-radius: 14px;
  color: #0f4c5c;
}

.cart-address-hint strong {
  display: block;
  margin-bottom: 0.2rem;
  font-size: 0.98rem;
}

.cart-address-hint small {
  color: #155e75;
  font-size: 0.88rem;
  line-height: 1.45;
}

.cart-address-edit {
  color: #2563eb;
  font-weight: 600;
  text-decoration: none !important;
}

.cart-address-edit:hover,
.cart-address-edit:focus {
  color: #1d4ed8;
}

.payment-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
  gap: 0.75rem;
  margin-top: 0.75rem;
}

.payment-chip {
  position: relative;
  overflow: hidden;
  min-height: 88px;
  padding: 0.9rem 0.85rem;
  border: 1px solid #cbd5e1;
  border-radius: 14px;
  background: #fff;
  text-align: left;
  color: #334155;
  box-shadow: 0 8px 20px rgba(15, 23, 42, 0.04);
  transition: border-color 0.18s ease, box-shadow 0.18s ease, transform 0.18s ease;
}

.payment-chip::after {
  position: absolute;
  right: 0.7rem;
  bottom: 0.35rem;
  font-size: 2rem;
  font-weight: 800;
  line-height: 1;
  opacity: 0.08;
  pointer-events: none;
}

.payment-chip--cash::after {
  content: "$";
}

.payment-chip--card::after,
.payment-chip--online::after {
  content: "◫";
}

.payment-chip--benefit::after {
  content: "✦";
}

.payment-chip--bank::after {
  content: "⌂";
}

.payment-chip strong {
  font-size: 1rem;
}

.payment-chip small {
  margin-top: 0.25rem;
  color: #64748b;
  white-space: normal;
}

.payment-chip--active {
  border-color: #2563eb;
  background: linear-gradient(180deg, #eff6ff 0%, #dbeafe 100%);
  box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.12);
  color: #1d4ed8;
}

.payment-chip--disabled {
  background: #f8fafc;
  color: #94a3b8;
  box-shadow: none;
}

.payment-chip--disabled small {
  color: #94a3b8;
}

.payment-chip--compact {
  min-height: 78px;
  text-align: center;
}

.amount-group .input-group-text {
  background: #eff6ff;
  border-color: #bfdbfe;
  color: #1d4ed8;
  font-weight: 700;
}

.amount-group .form-control {
  min-height: 48px;
  font-size: 1.1rem;
  font-weight: 700;
}

.payment-details {
  padding: 0.95rem 1rem;
  background: linear-gradient(180deg, #ecfeff 0%, #cffafe 100%);
  border: 1px solid #a5f3fc;
  border-radius: 14px;
  color: #155e75;
}

.payment-details__label {
  display: block;
  margin-bottom: 0.35rem;
  color: #0f766e;
  font-size: 0.78rem;
  font-weight: 800;
  letter-spacing: 0.08em;
  text-transform: uppercase;
}

.cart-delivery-toggle .btn {
  min-height: 74px;
  font-weight: 700;
}

.confirm-modal__hero {
  padding: 0.35rem 0 0.25rem;
}

.confirm-modal__eyebrow,
.confirm-modal__label {
  display: block;
  margin-bottom: 0.35rem;
  color: #0f766e;
  font-size: 0.76rem;
  font-weight: 800;
  letter-spacing: 0.08em;
  text-transform: uppercase;
}

.confirm-modal__grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  gap: 0.9rem;
}

.confirm-modal__card,
.confirm-ticket {
  padding: 1rem;
  border: 1px solid #dbe3ef;
  border-radius: 16px;
  background: linear-gradient(180deg, #ffffff 0%, #f8fafc 100%);
}

.confirm-ticket__header,
.confirm-ticket__row,
.confirm-ticket__total-row {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 0.8rem;
}

.confirm-ticket__item + .confirm-ticket__item {
  margin-top: 0.9rem;
  padding-top: 0.9rem;
  border-top: 1px dashed #cbd5e1;
}

.confirm-ticket__options {
  margin-top: 0.45rem;
  padding-left: 0.1rem;
}

.confirm-ticket__option {
  color: #475569;
  font-size: 0.92rem;
}

.confirm-ticket__totals {
  margin-top: 1rem;
  padding-top: 0.9rem;
  border-top: 1px solid #dbe3ef;
}

.confirm-ticket__total-row + .confirm-ticket__total-row {
  margin-top: 0.45rem;
}

.confirm-ticket__total-row--grand {
  margin-top: 0.75rem;
  padding-top: 0.75rem;
  border-top: 1px solid #cbd5e1;
  font-size: 1.02rem;
}

@media (max-width: 767px) {
  .cart-product__image {
    max-height: 180px;
  }
}
</style>

<script>
/* eslint-disable */
import { getCenter, isPointInPolygon, getDistance } from "geolib";
// import VueGoogleAutocomplete from "vue-google-autocomplete";
//import Slider from "../components/Slider";
const Slider = () =>
  import(/* webpackChunkName: "slider" */ "../components/Slider");
const Product = () =>
  import(/* webpackChunkName: "product" */ "../pages/Product");

export default {
  components: {
    // VueGoogleAutocomplete,
    Slider,
    Product,
  },
  data() {
    return {
      searching: false,
      tip: 0,
      rut: "",
      commune: "",
      time: -1,
      date: -1,
      type: "",
      payment: "",
      amount: 0,
      clientName: "",
      phone: "",
      email: "",
      notes: "",
      address: "",
      zone: {},
      zoom: 13,
      center: {
        lat: 0,
        lng: 0,
      },
      loading: false,
      comunne: {},
      addressGPS: {},
      page: {},
      editingProductId: null,
      editingProductName: "",
      editingProductModalKey: 0,
      productLookupCache: null,
      deliveryValueOverride: null,
      deliveryAddressKey: "",
      couponCode: "",
      coupon: {},
      cuponDisabled: false,
      timeout: null,
      addressAutocompleteTimeout: null,
      autoSelectedAddressQuery: "",
      hydratingCart: false,
    };
  },
  async mounted() {
    document.title = `Pedido - ${this.info.custom_name || this.info.name}`;
    window.scroll(0, 0);

    await this.loadRemoteCart({ force: true });
    this.applyDraftState();

    if (!this.clientName && this.$cookies.get("clientName"))
      this.clientName = this.$cookies.get("clientName");
    if (!this.phone && this.$cookies.get("phone"))
      this.phone = this.$cookies.get("phone");
    if (!this.email && this.$cookies.get("email"))
      this.email = this.$cookies.get("email");
    if (!this.address && this.$cookies.get("address")) {
      this.address = this.$cookies.get("address") || "";
    }
    if (this.$cookies.get("addressGPS")) {
      this.addressGPS = this.$cookies.get("addressGPS");
    }

    if (
      this.date == -1 &&
      this.days.length > 0 &&
      this.settings.scheduleEnabled
    ) {
      this.date = this.days[0].date;
    }

    if (
      this.$cookies.get("ticketId") &&
      this.$cookies.get("bid") == this.info._id
    ) {
      // check if ticket created today

      this.$router.push(
        this.getLink(`pedido/${this.$cookies.get("ticketId")}`)
      );
    }
    if (!this.center.lat && !this.center.lng) {
      this.centerMap();
    }
    this.restoreSavedAddressLocation();
    this.syncZoneFromCenter();

    let param = this.$store.state.isDomain
      ? this.$route.params.name
      : this.$route.params.id;

    let page = this.info.pages.find((p) => {
      if (p.slug == param) return p;
    });
    if (!page) {
      if (this.info.pages && this.info.pages.length >= 1) {
        let [firstPage] = this.info.pages;
        //this.$router.push(this.getLink(firstPage.slug));
      }
      // this.$router.push(`/${this.info.webName}`);
      return false;
    }

    this.$gtag.event("view_cart", {
      event_category: "cart",
      event_label: "User view cart",
      value: 1,
    });
  },
  methods: {
    applyDraftState() {
      const draft = this.$store.state.cartDraft || {};
      this.hydratingCart = true;
      this.tip = draft.tip || 0;
      this.rut = draft.rut || "";
      this.commune = draft.commune || "";
      this.time = this.normalizeScheduleTime(
        draft.time !== undefined ? draft.time : -1
      );
      this.date = draft.date !== undefined ? draft.date : -1;
      this.type = draft.type || "";
      this.amount = draft.amount || 0;
      this.clientName = draft.clientName || "";
      this.phone = draft.phone || "";
      this.email = draft.email || "";
      this.notes = draft.notes || "";
      this.address = draft.address || "";
      this.zone = draft.zone || {};
      this.center = draft.center || {
        lat: 0,
        lng: 0,
      };
      this.deliveryValueOverride =
        draft.deliveryValue !== undefined && draft.deliveryValue !== null
          ? Number(draft.deliveryValue) || 0
          : null;
      this.deliveryAddressKey = this.getDeliveryAddressKey(
        draft.address || "",
        draft.center || { lat: 0, lng: 0 }
      );
      this.couponCode = draft.couponCode || "";
      this.coupon = draft.coupon || {};
      this.cuponDisabled = draft.cuponDisabled || false;

      const paymentName =
        draft.payment && draft.payment.name ? draft.payment.name : draft.payment;
      this.payment =
        ((this.payments || []).find((payment) => payment.name == paymentName)) ||
        "";
      this.hydratingCart = false;
    },
    getDeliveryAddressKey(address = this.address, center = this.center) {
      const normalizedAddress = `${address || ""}`.trim().toLowerCase();
      const lat = center && center.lat ? Number(center.lat) : 0;
      const lng = center && center.lng ? Number(center.lng) : 0;
      return `${normalizedAddress}|${lat}|${lng}`;
    },
    invalidateStoredDeliveryValue() {
      this.deliveryValueOverride = null;
      this.deliveryAddressKey = "";
    },
    persistCartDraft() {
      if (this.hydratingCart) return;

      this.$store.commit("setCartDraft", {
        tip: this.tip,
        rut: this.rut,
        commune: this.commune,
        time: this.time,
        date: this.date,
        type: this.type,
        payment: this.payment,
        amount: this.amount,
        clientName: this.clientName,
        phone: this.phone,
        email: this.email,
        notes: this.notes,
        address: this.address,
        zone: this.zone,
        center: this.center,
        deliveryValue: this.deliveryValue,
        couponCode: this.couponCode,
        coupon: this.coupon,
        cuponDisabled: this.cuponDisabled,
      });
    },
    normalizeScheduleTime(value) {
      if (value === -1 || value === "-1" || value === null || value === undefined) {
        return -1;
      }

      if (typeof value === "string" && value.includes(":")) {
        const [hour, minute] = value.split(":").map(Number);
        if (Number.isNaN(hour) || Number.isNaN(minute)) return -1;
        return hour * 60 + minute;
      }

      const numericValue = Number(value);
      if (Number.isNaN(numericValue)) return -1;

      // Legacy format: stored as hour 0-23.
      if (numericValue >= 0 && numericValue <= 23) return numericValue * 60;

      return numericValue;
    },
    parseTimeStringToMinutes(value, fallback) {
      const [hour = fallback, minute = 0] = String(value || "")
        .split(":")
        .map(Number);
      return hour * 60 + minute;
    },
    formatScheduleTime(value) {
      const minutes = this.normalizeScheduleTime(value);
      if (minutes < 0) return "";

      const hour = Math.floor(minutes / 60);
      const minute = minutes % 60;
      return this.$moment()
        .hour(hour)
        .minutes(minute)
        .format("HH:mm");
    },
    isTodayDate(value) {
      return this.$moment(value).isSame(this.$moment(), "day");
    },
    syncZoneFromCenter() {
      if (!this.center || !this.center.lat || !this.center.lng) return;
      const lat = this.center.lat;
      const lng = this.center.lng;

      let zone = this.zones.find((z) => {
        let paths = z.paths.map((p) => {
          return { latitude: p.lat, longitude: p.lng };
        });

        let isIn = false;

        if (z.component == "banned") {
          isIn = isPointInPolygon({ latitude: lat, longitude: lng }, paths);
          if (isIn) return false;
        }

        if (z.type == "zone")
          isIn = isPointInPolygon({ latitude: lat, longitude: lng }, paths);
        else {
          let distance = getDistance(
            { latitude: z.center.lat, longitude: z.center.lng },
            { latitude: lat, longitude: lng }
          );
          let km = z.kms.find((km) => km.start <= distance && km.end >= distance);
          if (km) isIn = true;
        }

        return isIn;
      });

      if (zone) {
        this.zone = zone;
      }
    },
    restoreSavedAddressLocation() {
      const gps = this.addressGPS;
      if (!this.address || !gps || !gps.lat || !gps.lng) return;

      this.center = {
        lat: Number(gps.lat),
        lng: Number(gps.lng),
      };
      this.zoom = 16;
      this.syncZoneFromCenter();
    },
    changeAddress() {
      this.$refs["modalAddress"].show();
    },
    checkPayment(p) {
      if (!p.avaiable_types) return false;
      if (p.avaiable_types.includes("all")) return false;
      return !p.enabled || !p.avaiable_types.includes(this.type);
    },
    recomendedTip() {
      this.tip = parseInt(this.total * 0.1);
    },
    setTip(value) {
      this.tip = value;
    },
    setTotal() {
      this.amount = this.total + this.tip;
    },
    useLocation() {
      navigator.geolocation.getCurrentPosition((position) => {
        this.center = {
          lat: position.coords.latitude,
          lng: position.coords.longitude,
        };
        //this.centerMap();
      });
    },
    applyCoupon() {
      if (!this.couponCode)
        return this.$swal({
          title: "Lo sentimos",
          text: "Debes ingresar un código de cupón",
        });
      if (this.products.length == 0)
        return this.$swal({
          title: "Lo sentimos",
          text: "No puedes aplicar un cupón a un pedido vacío",
        });
      this.loading = true;
      this.coupon = {};
      const id = this.$store.state.info.webName;
      console.log("id", id);
      if (!id || id == undefined) return false;

      this.$http
        .post(`${id}/coupon`, { code: this.couponCode, b: this.info._id })
        .then((res) => {
          let coupon = res.data.data;
          //this.ticket.coupon = this.coupon._id;

          if (
            (coupon.min && this.total < coupon.min) ||
            (coupon.max && this.total > coupon.max)
          )
            return this.$swal({
              title: "Lo sentimos",
              text: `El cupón no es válido para este monto \n Min: $${this.formatNumber(
                coupon.min
              )} - Max: $${this.formatNumber(coupon.max)}`,
            });

          if (coupon.only && coupon.only.length > 0) {
            // check if product cart contains coupon only product
            let ids = coupon.only.map((p) => p.code);
            let filter = this.products.filter((p) => !ids.includes(p.code));

            if (filter && filter.length > 0)
              return this.$swal({
                title: "Lo sentimos",
                text: "El cupón no es válido para este pedido\nSolo aplica a los productos seleccionados",
              });
          }

          if (coupon.exclude && coupon.exclude.length > 0) {
            // check if product cart contains coupon only product
            let ids = coupon.exclude.map((p) => p.code);
            let filter = this.products.filter((p) => ids.includes(p.code));

            if (filter && filter.length > 0)
              return this.$swal({
                title: "Lo sentimos",
                text: "El cupón no es válido para este pedido\nNo aplica a los productos seleccionados",
              });
          }

          this.coupon = coupon;
          this.cuponDisabled = true;
        })
        .catch((err) => {
          this.$swal({
            title: "Error",
            text: "Error al aplicar el codigo",
            icon: "error",
          });
          //this.$refs["couponInput"].focus();
        })
        .finally(() => {
          this.loading = false;
        });

      this.$gtag.event("apply_coupon", {
        event_category: "coupon",
        event_label: "User apply coupon",
        value: 1,
      });
    },
    openAddres() {
      this.openInMaps(`${this.info.address} - ${this.info.commune}`);
    },
    normalizePaymentLabel(name = "") {
      const normalized = `${name || ""}`.trim();
      if (!normalized) return "";

      const keep = {
        Webpay: "Webpay",
        MercadoPago: "Mercado Pago",
        Klap: "Klap",
        sodexo: "Sodexo",
        edenred: "Edenred",
        amipass: "Amipass",
      };

      return normalized
        .split(/\s+/)
        .map((word) => {
          const clean = word.trim();
          if (!clean) return "";
          const lower = clean.toLowerCase();
          if (keep[clean]) return keep[clean];
          if (keep[lower]) return keep[lower];
          return lower.charAt(0).toUpperCase() + lower.slice(1);
        })
        .join(" ");
    },
    confirmTicket() {
      if (this.amount < this.total && this.payment.needAmount) {
        this.$swal({
          title: "Lo sentimos",
          text: "El monto ingresado es menor al total del pedido",
        });
        return false;
      }
      this.$refs["modal"].show();
      // this.sendTicket()
    },
    getAddressData(data) {
      const { geometry, name, vicinity, formatted_address } = data;
      // console.log({formatted_address})
      // console.log({data})

      // this.address = `${name}, ${vicinity}`;
      const lat = geometry.location.lat();
      const lng = geometry.location.lng();
      // console.log({ data, lat, lng });

      this.address = `${vicinity || ""}`;
      console.log({ data, lat, lng });
      this.addressGPS = { lat, lng };

      let zone = this.zones.find((z) => {
        console.log({ z });
        let paths = z.paths.map((p) => {
          return { latitude: p.lat, longitude: p.lng };
        });

        let isIn = false;

        if (z.component == "banned") {
          isIn = isPointInPolygon({ latitude: lat, longitude: lng }, paths);
          if (isIn) {
            this.zone = {};
            return this.$swal({
              title: "Lo sentimos",
              text: "La direccion ingresada no esta disponible para envios",
            });
          }
        }
        if (z.type == "zone")
          isIn = isPointInPolygon({ latitude: lat, longitude: lng }, paths);
        else {
          console.log("calculating distance");
          let distance = getDistance(
            { latitude: z.center.lat, longitude: z.center.lng },
            { latitude: lat, longitude: lng }
          );
          let km = z.kms.find(
            (km) => km.start <= distance && km.end >= distance
          );
          console.log({ km });
          if (km) isIn = true;
        }

        if (isIn && z.minDelivery && z.minDelivery > this.total) {
          this.zone = {};
          return this.$swal({
            title: "Lo sentimos",
            text: `El monto minimo para envios a esta zona es de $${this.formatNumber(
              z.minDelivery
            )}`,
          });
        }

        // console.log({ name: z.name, isIn });
        // console.table(paths);
        if (isIn) {
          this.zoom = 16;
          this.zone = z;
          this.center = { lat, lng };
          return z;
        }
        // else {
        //   this.$swal({
        //     title: "Lo sentimos",
        //     text: "No se encontro un valor para la distancia",
        //   });
        // }
      });
      if (!zone) {
        //alert('Fuera de la zona de reparto')
        this.$swal({
          title: "Lo sentimos",
          text: "La dirección esta fuera de la zona de reparto",
        });
        // this.center = data.location;
        this.zoom = 16;
        this.center = { lat, lng };
        this.zone = {};
      }
    },
    centerMap() {
      let zones = [];
      this.zones.forEach((zone) => {
        let z = zone.paths.map((z) => ({ latitude: z.lat, longitude: z.lng }));
        zones.push(...z);
      });

      let center = getCenter(zones);

      if (center) this.center = { lat: center.latitude, lng: center.longitude };
    },
    focusAddressInput() {
      this.$nextTick(() => {
        const addressRef = this.$refs["addressInput"];
        const addressComponent = Array.isArray(addressRef)
          ? addressRef[0]
          : addressRef;
        const addressElement = addressComponent?.$el || addressComponent;
        const input =
          addressElement?.tagName === "INPUT"
            ? addressElement
            : addressElement?.querySelector?.("input");

        if (input) {
          this.bindAddressAutocompleteAutoSelect(input);
          input.focus();
        }
      });
    },
    bindAddressAutocompleteAutoSelect(input) {
      if (!input || input.dataset.autoselectBound === "true") return;

      input.dataset.autoselectBound = "true";
      input.addEventListener("input", () => {
        clearTimeout(this.addressAutocompleteTimeout);
        this.addressAutocompleteTimeout = setTimeout(
          () => this.tryAutoSelectAddress(input.value),
          350
        );
      });
    },
    tryAutoSelectAddress(query) {
      const text = (query || "").trim();
      if (text.length < 3 || this.autoSelectedAddressQuery === text) return;
      if (!window.google?.maps?.places) return;

      const autocompleteService =
        this.autocompletePredictionService ||
        new window.google.maps.places.AutocompleteService();
      this.autocompletePredictionService = autocompleteService;

      autocompleteService.getPlacePredictions(
        {
          input: text,
          componentRestrictions: { country: "CL" },
        },
        (predictions, status) => {
          if (
            status !== window.google.maps.places.PlacesServiceStatus.OK ||
            !predictions ||
            predictions.length !== 1
          ) {
            return;
          }

          const [prediction] = predictions;
          const placesService =
            this.addressPlacesService ||
            new window.google.maps.places.PlacesService(document.createElement("div"));
          this.addressPlacesService = placesService;

          placesService.getDetails(
            { placeId: prediction.place_id },
            (place, detailsStatus) => {
              if (
                detailsStatus !== window.google.maps.places.PlacesServiceStatus.OK ||
                !place?.geometry
              ) {
                return;
              }

              this.autoSelectedAddressQuery = text;
              this.getAddressData(place);
              this.$refs["modalAddress"]?.hide();
            }
          );
        }
      );
    },
    searchAddressWeb() {
      console.log("search address");
      this.searching = true;
      this.$http
        .get("address", {
          params: {
            address: this.address,
          },
        })
        .then((res) => {
          console.log(res.data);
          const data = res.data.data;

          if (data.length == 0) {
            // find other way
            this.$refs["modalAddress"].show();
          } else {
            // get first result
            const [result] = data;
            console.log({
              data,
              result,
            });

            const lat = result.lat;
            const lng = result.lng;
            this.addressGPS = { lat, lng };

            let zone = this.zones.find((z) => {
              console.log({ z });
              let paths = z.paths.map((p) => {
                return { latitude: p.lat, longitude: p.lng };
              });

              let isIn = false;

              if (z.component == "banned") {
                isIn = isPointInPolygon(
                  { latitude: lat, longitude: lng },
                  paths
                );
                if (isIn) {
                  this.zone = {};
                  return this.$swal({
                    title: "Lo sentimos",
                    text: "La direccion ingresada no esta disponible para envios",
                  });
                }
              }
              if (z.type == "zone")
                isIn = isPointInPolygon(
                  { latitude: lat, longitude: lng },
                  paths
                );
              else {
                console.log("calculating distance");
                let distance = getDistance(
                  { latitude: z.center.lat, longitude: z.center.lng },
                  { latitude: lat, longitude: lng }
                );
                let km = z.kms.find(
                  (km) => km.start <= distance && km.end >= distance
                );
                console.log({ km });
                if (km) isIn = true;
              }

              if (isIn && z.minDelivery && z.minDelivery > this.total) {
                this.zone = {};
                return this.$swal({
                  title: "Lo sentimos",
                  text: `El monto minimo para envios a esta zona es de $${this.formatNumber(
                    z.minDelivery
                  )}`,
                });
              }

              // console.log({ name: z.name, isIn });
              // console.table(paths);
              if (isIn) {
                this.zoom = 16;
                this.zone = z;
                this.center = { lat, lng };
                this.addressGPS = { lat, lng };
                return z;
              }
              // else {
              //   this.$swal({
              //     title: "Lo sentimos",
              //     text: "No se encontro un valor para la distancia",
              //   });
              // }
            });
            if (!zone) {
              //alert('Fuera de la zona de reparto')
              this.$swal({
                title: "Lo sentimos",
                text: "La dirección esta fuera de la zona de reparto",
              });
              // this.center = data.location;
              this.zoom = 16;
              this.center = { lat, lng };
              this.addressGPS = { lat, lng };
              this.zone = {};
            }
          }
        })
        .finally(() => {
          this.searching = false;
        });
    },
    searchAddress() {
      console.log("search address");
      if (this.address.length < 3) return false;
      //if (!this.comunne._id) return false;

      this.$http
        .post("cords", {
          address: `${this.address}`,
          //zone: this.comunne,
        })
        .then((res) => {
          let data = res.data.data;
          if (data.location) {
            let { lat, lng } = data.location;
            // console.log({ lat, lng });

            let zone = this.zones.find((z) => {
              let paths = z.paths.map((p) => {
                return { latitude: p.lat, longitude: p.lng };
              });
              let isIn = isPointInPolygon(
                { latitude: lat, longitude: lng },
                paths
              );
              console.log({ name: z.name, isIn });
              // console.table(paths);
              if (isIn) {
                if (z.type == "banned") {
                  console.log("banned");
                  return false;
                }
                this.zoom = 16;
                this.zone = z;
                this.center = data.location;
                return z;
              }
            });
            if (!zone) {
              //alert('Fuera de la zona de reparto')
              this.$swal({
                title: "Lo sentimos",
                text: "La dirección esta fuera de la zona de reparto",
              });
              this.center = data.location;
              this.zoom = 13;
              this.zone = {};
            }
          } else {
            this.comunne = {};
            this.$swal({
              title: "Lo sentimos",
              text: "La dirección esta fuera de la zona de reparto",
            });
            this.center = data.location;
            this.zoom = 13;
            this.zone = {};
          }
        });
    },
    sendTicket() {
      this.loading = true;
      this.persistCartDraft();

      const checkoutPayload = {
        bid: this.$store.state.info._id,
        clientName: this.clientName || "",
        rut: this.rut || "",
        phone: this.phone || "",
        email: this.email || "",
        type: this.type || "",
        address: this.address
          ? `${this.address}${this.commune ? ` ${this.commune}` : ""}`.trim()
          : "",
        gps: this.center || { lat: 0, lng: 0 },
        payment: this.payment ? this.payment.name || this.payment : "",
        amount: this.amount || 0,
        deliveryValue: Number(this.deliveryValue) || 0,
        coupon: this.coupon || {},
        date: this.date !== undefined ? this.date : -1,
        time: this.time !== undefined ? this.time : -1,
        tip: this.tip || 0,
        notes: this.notes || "",
      };

      try {
        this.$analytics.fbq("track", "Purchase", {
          value: this.total,
        });
        this.$gtag.event("send_ticket", {
          event_category: "ticket",
          event_label: "User send ticket",
          value: 1,
        });
      } catch (error) {
        console.log("Error analytics");
      }

      this.syncRemoteCart()
        .then(() =>
          this.$http.post(
            "cart/checkout",
            checkoutPayload,
            { headers: this.getCartHeaders() }
          )
        )
        .then((res) => {
          console.log(res);
          this.$store.commit("setCartLoadedBusiness", null);
          this.$store.commit("clearProducts");
          this.$store.commit("replaceCartDraft", {});
          // save ticket id to cookies
          this.$cookies.set("ticketId", res.data.data._id, 60 * 60 * 6);
          this.$cookies.set("bid", this.info._id);
          this.$router.push(this.getLink(`pedido/${res.data.data._id}`));
        })
        .catch((err) => {
          let msg =
            (err.body && (err.body.details || err.body.message)) ||
            (err.data && (err.data.details || err.data.message)) ||
            "Error al enviar el pedido";
          this.$swal({
            title: "Error",
            text: msg,
            icon: "error",
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },
    removeProduct(p) {
      let ps = this.products.filter((pr) => pr != p);
      this.$store.commit("setProducts", ps);
      if (this.total < this.settings.minDelivery) {
        this.type = "Retiro";
      }

      this.$gtag.event("remove_product", {
        event_category: "cart",
        event_label: "User remove product from cart",
        value: 1,
      });
    },
    handleEditProductSuccess() {
      console.log("cart edit modal success");
      this.$refs["modalEditProduct"]?.hide();
    },
    closeEditProductModal() {
      console.log("cart edit modal hide event");
      this.$store.commit("clearEditingCartProduct");
      this.editingProductId = null;
      this.editingProductName = "";
      this.editingProductModalKey = 0;
    },
    getCartProductId(product) {
      if (!product) return null;

      const candidates = [
        product.product && product.product._id ? product.product._id : null,
        product.ref && product.ref._id ? product.ref._id : null,
        product.id || null,
        product.pid || null,
        product.product,
        product._id,
      ];

      return candidates.find((candidate) => {
        return typeof candidate == "string" || typeof candidate == "number";
      });
    },
    async resolveLegacyCartProductId(product) {
      const code = `${product && product.code ? product.code : ""}`.trim();
      const name = `${product && product.name ? product.name : ""}`.trim().toLowerCase();
      if (!code && !name) return null;

      if (!this.productLookupCache) {
        const { webName } = this.$store.state.info;
        const res = await this.$http.get(`${webName}/product?order=name&limit=500`);
        this.productLookupCache = Array.isArray(res.data.data) ? res.data.data : [];
      }

      const byCode = code
        ? this.productLookupCache.find((item) => `${item.code || ""}`.trim() === code)
        : null;
      if (byCode && byCode._id) return byCode._id;

      const byName = name
        ? this.productLookupCache.find(
            (item) => `${item.name || ""}`.trim().toLowerCase() === name
          )
        : null;
      if (byName && byName._id) return byName._id;

      return null;
    },
    async editProduct(product) {
      console.log("edit cart product", product);
      try {
        let productId = this.getCartProductId(product);
        console.log("edit cart product id", productId);
        if (!productId) {
          productId = await this.resolveLegacyCartProductId(product);
          console.log("resolved legacy cart product id", productId);
        }
        if (!product || !productId) return;

        const draftOptions = (product.options || []).map((option) => ({
          _id: option._id,
          label: option.label || option.name || "",
          name: option.name || option.label || "",
          type: option.type,
          multiple: !!option.multiple,
          parent: option.parent || null,
          selected:
            option.type == "number"
              ? Number(option.selected) || 0
              : option.selected || "",
          selectedId: null,
          selectedName:
            !option.multiple && option.type != "number"
              ? (option.selected && option.selected.name
                  ? option.selected.name
                  : option.selected || "")
              : "",
          selectedIds: option.multiple
            ? (option.values || []).map((value) => value && value._id).filter(Boolean)
            : [],
          selectedNames: option.multiple
            ? (
                (option.values && option.values.length
                  ? option.values.map((value) => value && value.name)
                  : `${option.selected || ""}`
                      .split(",")
                      .map((value) => value.trim())
                )
              ).filter(Boolean)
            : [],
        }));
        console.log("edit cart draft options", draftOptions);

        const draft = {
          qty: product.qty || 1,
          details: product.details || "",
          activeOptionIndex: 0,
          options: draftOptions,
        };

        this.$store.commit("setProductDraft", {
          productId,
          draft,
        });
        console.log("edit cart draft saved");

        this.$store.commit("setEditingCartProduct", {
          tempid: product.tempid || product._id,
          productId,
        });
        console.log("edit cart editing state saved");

        this.editingProductId = productId;
        this.editingProductName = product.name || "Editar producto";
        this.editingProductModalKey += 1;
        console.log("edit cart state ready", {
          editingProductId: this.editingProductId,
          editingProductName: this.editingProductName,
          editingProductModalKey: this.editingProductModalKey,
        });

        this.$nextTick(() => {
          console.log("opening cart edit modal", {
            productId: this.editingProductId,
            modalRef: !!this.$refs["modalEditProduct"],
          });
          this.$refs["modalEditProduct"]?.show();
          if (this.$bvModal) {
            this.$bvModal.show("cart-edit-product-modal");
          }
        });
      } catch (error) {
        console.error("edit cart product error", error);
        this.$swal({
          title: "Error",
          text: "No se pudo abrir el editor de este producto",
          icon: "error",
        });
      }
    },
    getNextOpenDay() {
      let day = this.$moment().add(this.date, "days").day();
      let days = this.settings.days;
      let nextDay = days.find((d) => d.n > day && d.openAt && d.closeAt);
      if (!nextDay) {
        this.date += 1;
        return this.getNextOpenDay();
      }
      console.log({ nextDay });
      return nextDay;
    },
  },
  computed: {
    days() {
      // const curentDayNumber = this.$moment().day();
      // const nextThreeDaysOfNextWeek = this.settings.days.filter((d) => d.openAt && d.closeAt).slice(0, 3);
      let days = this.settings.days.filter((d) => d.openAt && d.closeAt);
      if (!days) return [];
      let daysplain = days.map((d) => d.n);

      const nextSevenDays = [];

      for (let i = 0; i < 7; i++) {
        const dayopen = days[i];

        const day = this.$moment().add(i, "days");
        const dayNumber = day.day();
        console.log({ dayNumber });

        if (daysplain.includes(dayNumber)) {
          const isToday = day.isSame(this.$moment(), "day");
          const isTomorrow = day.isSame(this.$moment().add(1, "day"), "day");
          nextSevenDays.push({
            n: day.format("d"),
            text: isToday
              ? `Hoy, ${day.format("dddd DD [de] MMMM")}`
              : isTomorrow
                ? `Mañana, ${day.format("dddd DD [de] MMMM")}`
                : day.format("dddd DD [de] MMMM"),
            date: day.format("YYYY-MM-DD"),
            data: days[i],
          });
        } else {
          console.log("dayopen", dayopen);
        }
      }
      console.log({ nextSevenDays, days });
      return nextSevenDays;
    },
    hours() {
      let currentDay = this.settings.days.find(
        (d) => d.n == this.$moment(this.date).day()
      );

      console.log({ currentDay });

      if (!currentDay) {
        //this.date += 1;
        return [];
      }
      if (!currentDay.openAt || !currentDay.closeAt) {
        this.time = -1;
        return [];
      }

      let openAt = this.parseTimeStringToMinutes(
        currentDay ? currentDay.openAt : "06:00",
        6
      );
      let closeAt = this.parseTimeStringToMinutes(
        currentDay ? currentDay.closeAt : "23:00",
        23
      );

      console.log({ currentDay, openAt, closeAt });

      let hours = [];

      let startAt = openAt;
      if (this.isTodayDate(this.date)) {
        const now = this.$moment().add(2, "hours");
        const roundedMinutes = Math.ceil(now.minutes() / 30) * 30;
        now.minutes(roundedMinutes === 60 ? 0 : roundedMinutes);
        if (roundedMinutes === 60) now.add(1, "hour");
        now.seconds(0);
        startAt = Math.max(startAt, now.hour() * 60 + now.minutes());
      }

      const firstSlot = Math.ceil(startAt / 30) * 30;
      for (let i = firstSlot; i < closeAt; i += 30) {
        hours.push(i);
      }

      if (currentDay && currentDay.openAt == "" && currentDay.closeAt == "") {
        this.date = 0;
        this.time = -1;
        this.$swal({
          title: "Lo sentimos",
          text: "El día seleccionado no tenemos horarios de atención",
        });
        setTimeout(() => {
          this.date += 1;
        }, 800);
      }

      const normalizedTime = this.normalizeScheduleTime(this.time);
      if (normalizedTime !== -1 && !hours.includes(normalizedTime)) {
        this.time = -1;
      }

      return hours;
    },
    cuponTotal() {
      let discount = 0;
      let coupon = this.coupon;
      if (coupon && coupon._id) {
        if (coupon.to == "delivery") {
          if (coupon.type == "percent") {
            discount = this.deliveryValue * (coupon.amount / 100);
          } else {
            discount = coupon.amount;
          }

          if (discount > this.deliveryValue) discount = this.deliveryValue;
        } else if (coupon.to == "subtotal") {
          if (coupon.type == "percent") {
            discount = this.subtotal * (coupon.amount / 100);
          } else {
            discount = coupon.amount;
          }

          if (discount > this.subtotal) discount = this.subtotal;
        }
        if (coupon.to == "total") {
          if (coupon.type == "percent") {
            discount = this.total * (coupon.amount / 100);
          } else {
            discount = coupon.amount;
          }

          if (discount > this.total) discount = this.total;
        }
      }
      return discount;
    },
    paymentDetails() {
      return (
        this.payment &&
        this.payment.details
          .replace(/\n/g, "<br>")
          .replace("<a", '<a target="_blank" class="font-weight-bold"')
      );
    },
    shippingEnabled() {
      let { shippingEnabled } = this.info.settings;
      return shippingEnabled;
    },
    pickupEnabled() {
      let { pickupEnabled } = this.info.settings;
      return pickupEnabled;
    },
    deliveryEnabled() {
      let { deliveryEnabled } = this.info.settings;
      return deliveryEnabled;
    },
    deliveryValue() {
      if (!["Domicilio", "Envio"].includes(this.type)) return 0;
      if (
        this.deliveryValueOverride !== null &&
        this.deliveryAddressKey &&
        this.deliveryAddressKey === this.getDeliveryAddressKey()
      ) {
        return Number(this.deliveryValueOverride) || 0;
      }
      if (this.zone._id) {
        let deliveryValue = this.zone.value;

        if (this.zone.type == "km") {
          let distance = getDistance(
            { latitude: this.zone.center.lat, longitude: this.zone.center.lng },
            { latitude: this.center.lat, longitude: this.center.lng }
          );
          console.log("kms", this.zone.kms);
          let km = this.zone.kms.find(
            (km) => km.start <= distance && km.end >= distance
          );
          console.log({ km });
          if (km) deliveryValue = km.value;
          else this.$swal("Error", "No se encontró zona para la distancia");
          console.log("distance", distance);
        }

        return deliveryValue;
      }
      return 0;
    },
    comunnes() {
      let data = [];
      if (this.info && this.info.settings && this.info.settings.comunnes)
        data = this.info.settings.comunnes;
      return data;
    },
    zones() {
      let data = [];
      if (this.info && this.info.settings && this.info.settings.zones)
        data = this.info.settings.zones;
      return data;
    },
    settings() {
      return this.info && this.info.settings ? this.info.settings : {};
    },
    payments() {
      return this.settings.payments;
    },
    info() {
      return this.$store.state.info;
    },
    ticketState() {
      if (this.loading) return false;
      if (this.status() == "Offline") return false;
      if (
        this.settings.pickupEnabled == false &&
        this.settings.deliveryEnabled == false
      )
        return false;
      if (this.type == "") return false;
      if (this.clientName.length < 3) return false;
      if (this.phone.length != 9) return false;
      if (this.emailIsValid) return false;
      if (this.payment == "") return false;
      if (this.products.length == 0) return false;
      if (!this.zone._id && this.type == "Domicilio") return false;
      return true;
    },
    emailIsValid() {
      const email = this.email;
      var re =
        /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return !re.test(String(email).toLowerCase());
    },
    subtotal() {
      return this.products.reduce((t, a) => t + a.total, 0);
    },
    total() {
      let total =
        this.products.reduce((t, a) => t + a.total, 0) + this.deliveryValue;

      return total;
    },
    products() {
      return this.$store.state.products;
    },
  },
  watch: {
    info() {
      if (!this.info || !this.info._id) return;
      this.loadRemoteCart({ force: true }).then(() => {
        this.applyDraftState();
        this.syncZoneFromCenter();
      });
    },
    payment() {
      if (this.payment && this.payment.needAmount) {
        setTimeout(() => {
          this.$refs["amountInput"].focus();
        }, 500);
      }
      console.log("types", this.settings.payments);
      console.log("payment", this.payment);
      if (
        this.payment &&
        this.payment.avaiable_types &&
        this.payment.avaiable_types.includes(this.type)
      ) {
        console.log("ok");
      } else {
        this.paymennt = "";
      }
      this.persistCartDraft();
    },
    products() {
      //this.setTotal();
      this.persistCartDraft();
    },
    deliveryValue() {
      this.amount = this.total;
      this.persistCartDraft();
    },
    cuponTotal() {
      this.amount = this.total;
      this.persistCartDraft();
    },
    type() {
      const type = this.type;
      const types = {
        Retiro: "pickup",
        Domicilio: "delivery",
        Envio: "shipping",
      };

      this.payment = "";

      const productsWithAvailability = this.products.filter(
        (p) => p.available_on && p.available_on.length > 0
      );

      console.log({ productsWithAvailability });

      if (productsWithAvailability.some((p) => p.available_on != types[type])) {
        const productName = productsWithAvailability.find(
          (p) => p.available_on != types[type]
        ).name;
        this.$swal({
          title: "Lo sentimos",
          text:
            "Uno o mas productos seleccionados no estan disponibles para esta opción.\n\n" +
            productName,
        });
        this.type = "";
        //this.$store.commit("clearProducts");
        //this.$router.push(this.getLink("pedido"));
      }

      if (type == "Domicilio") {
        setTimeout(() => {
          this.focusAddressInput();
          //this.$refs["addressInput"].focus();
          //this.$refs["addressInput"].update(this.$cookies.get("address"));
          //this.$refs['addressInput'].updateCoordinates(this.$cookies.get("addressGPS"));
        }, 1500);
      }
      this.persistCartDraft();
    },
    clientName() {
      this.$cookies.set("clientName", this.clientName);
      this.persistCartDraft();
    },
    rut() {
      this.persistCartDraft();
    },
    commune() {
      this.persistCartDraft();
    },
    phone() {
      this.$cookies.set("phone", this.phone);
      this.persistCartDraft();
    },
    email() {
      this.$cookies.set("email", this.email);
      this.persistCartDraft();
    },
    address() {
      this.$cookies.set("address", this.address);
      if (this.autoSelectedAddressQuery && this.autoSelectedAddressQuery !== this.address) {
        this.autoSelectedAddressQuery = "";
      }
      if (!this.hydratingCart) {
        this.invalidateStoredDeliveryValue();
      }
      this.persistCartDraft();
      // clear timeout
      clearTimeout(this.timeout);
      // set timeout for search
      // if (this.type == "Domicilio")
      //   this.timeout = setTimeout(this.searchAddressWeb, 2000);
    },
    addressGPS() {
      this.$cookies.set("addressGPS", this.addressGPS);
      if (!this.hydratingCart) {
        this.invalidateStoredDeliveryValue();
      }
    },
    notes() {
      this.persistCartDraft();
    },
    tip() {
      this.persistCartDraft();
    },
    amount() {
      this.persistCartDraft();
    },
    time() {
      this.persistCartDraft();
    },
    date() {
      this.persistCartDraft();
    },
    couponCode() {
      this.persistCartDraft();
    },
    cuponDisabled() {
      this.persistCartDraft();
    },
    coupon: {
      deep: true,
      handler() {
        this.persistCartDraft();
      },
    },
    center: {
      deep: true,
      handler() {
        if (!this.hydratingCart) {
          this.invalidateStoredDeliveryValue();
        }
        this.syncZoneFromCenter();
        this.persistCartDraft();
      },
    },
    zone: {
      deep: true,
      handler() {
        this.persistCartDraft();
      },
    },
  },
};
</script>
